import { colorForMember, initialsOf } from '../lib/memberColors';

export interface AvatarProps {
  memberId: string;
  displayName: string;
  size?: number;
  /** Dims the tile for a seat nobody has claimed yet. */
  muted?: boolean;
}

/**
 * A person, as a coloured tile with their initials.
 *
 * Replaces the identical grey people-glyph that used to sit against every
 * name. On the settle-up screen especially, six rows of the same icon told you
 * nothing; a colour you can learn does.
 *
 * The colour comes from the member id, so it is stable across screens and
 * across everyone else's phone — see src/lib/memberColors.ts.
 */
export function Avatar({ memberId, displayName, size = 40, muted = false }: AvatarProps) {
  const { ink, tint } = colorForMember(memberId);

  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: tint,
        color: ink,
        borderRadius: '50%',
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize: Math.round(size * 0.38),
        letterSpacing: '0.01em',
        opacity: muted ? 0.55 : 1,
        userSelect: 'none',
      }}
    >
      {initialsOf(displayName)}
    </div>
  );
}
